<template>
    <div class="card">
        <div
            class="card-img-top"
            :style="{
                backgroundImage:
                    'url(' +
                    this.recipe.image +
                    '), url(/img/food-placeholder.png)',
            }"
        ></div>
        <div class="card-body">
            <h4 class="card-title">{{ recipe.name }}</h4>
            <h5
                class="card-subtitle mb-2 text-muted"
                v-if="show_category && typeof recipe.categories !== undefined"
            >
                <a
                    href="/categories/uncategorized"
                    v-if="recipe.categories.length === 0"
                    >Category: Uncategorized</a
                >
                <a :href="'/categories/' + recipe.categories[0].slug" v-else
                    >Category: {{ recipe.categories[0].name }}</a
                >
            </h5>
            <a
                :href="recipe_url"
                class="btn btn-primary stretched-link"
                :title="recipe.name"
                >View Recipe</a
            >
        </div>
    </div>
</template>

<script>
export default {
    name: "RecipeCard",
    props: ["recipe", "show_category"],
    data() {
        return {
            show: false,
            recipe_url: "/recipes/" + this.recipe.slug,
        };
    },
};
</script>
<style scoped>
.card-img-top {
    height: 150px;
    width: 100%;
    background-size: cover;
    background-position: center;
}
</style>
